import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import { Form } from "react-formio";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import ScaleLoader from "react-spinners/ScaleLoader";
import {
  getSurveyForm,
  submitSurveyDetails,
  updateSurveyParticipantResponsesStatus,
} from "../../Utils/surveyFunctions";
let SurveyForm = () => {
  const { ip_address } = useContext(globalInfo);
  const { formKey } = useParams();
  const navigate = useNavigate();
  const [surveyID, setSurveyId] = useState("");
  const [participantID, setParticipantId] = useState("");
  const [formJson, setFormJson] = useState([]);
  const [surveyName, setSurveyName] = useState("");
  const [companyLogo, setCompanyLogo] = useState("");
  const [loading, setLoading] = useState(false)
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSurveyForm(formKey);
      if (response.status === "success") {
        const formJSON = JSON.parse(response.getFormJson)?.map(( item,index )=> {
          if(item.label?.toLowerCase() !== "submit"){
            return ({...item, label:`${index+1}. ${item.label}`})
          }
          else return item
        })
        setFormJson(formJSON);
        setSurveyName(response.getSurveyName);
        setSurveyId(response.getSurveyID);
        setParticipantId(response.getParticipantID);
        setCompanyLogo(response.getCompanyLogo);
        const bodyFormData = new FormData();
        bodyFormData.append("survey_id", response.getSurveyID);
        bodyFormData.append("participant_id", response.getParticipantID);
        bodyFormData.append("status", "survey_open");
        bodyFormData.append("ip_address", ip_address);
        if (response.getStatusType === "InvalidLink") {
          navigate("/Survey404");
          return false;
        } else if (
          response.getSurveyStatus === "completed" ||
          response.getSurveyStatus === "survey_closed" ||
          response.getSurveyStatus === "final_save" ||
          response.getSurveyStatus === "survey_approved"
        ) {
          navigate("/SurveyClosed");
          return false;
        } else if (
          response.getParticipantLastAction.includes("survey_attempted")
        ) {
          navigate("/survey-already-taken");
          return false;
        } else if (response.getParticipantLastAction.includes("disqualified")) {
          navigate("/SurveyNotEligible");
          return false;
        } else {
          if (response.getParticipantQualificationStatus === "yes") {
            if (
              response.getParticipantLastAction.length === 0 ||
              (response.getParticipantLastAction.length !== 0 &&
                response.getParticipantLastAction.includes("survey_open") &&
                !response.getParticipantLastAction.includes("qualified"))
            ) {
              await updateSurveyParticipantResponsesStatus(bodyFormData);
              navigate("/SurveyParticipantQualification/" + formKey);
            } else if (
              response.getParticipantLastAction.length !== 0 &&
              response.getParticipantLastAction.includes("qualified") &&
              !response.getParticipantLastAction.includes("disclaimer_agreed")
            ) {
              await updateSurveyParticipantResponsesStatus(bodyFormData);
              navigate("/SurveyConsent/" + formKey);
            } else if (
              response.getParticipantLastAction.length !== 0 &&
              response.getParticipantLastAction.includes("qualified") &&
              response.getParticipantLastAction.includes("disclaimer_agreed")
            ) {
              await updateSurveyParticipantResponsesStatus(bodyFormData);
            }
          } else {
            if (response.getParticipantLastAction.length === 0) {
              await updateSurveyParticipantResponsesStatus(bodyFormData);
              navigate("/SurveyConsent/" + formKey);
            } else if (
              response.getParticipantLastAction.length !== 0 &&
              response.getParticipantLastAction.includes("survey_open") &&
              !response.getParticipantLastAction.includes("disclaimer_agreed")
            ) {
              updateSurveyParticipantResponsesStatus(bodyFormData);
              navigate("/SurveyConsent/" + formKey);
            } else if (
              response.getParticipantLastAction.includes("disclaimer_agreed") &&
              !response.getParticipantLastAction.includes(
                "disclaimer_disagreed"
              )
            ) {
              updateSurveyParticipantResponsesStatus(bodyFormData);
            } else if (
              response.getParticipantLastAction.includes("disclaimer_agreed") &&
              response.getParticipantLastAction.includes("disclaimer_disagreed")
            ) {
              updateSurveyParticipantResponsesStatus(bodyFormData);
            }
          }
        }
      } else {
        navigate("/Survey404");
        return false;
      }
    }
    fetchAPI1();
  }, []);

  function saveFormData(data) {
    setLoading(true)
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("participant_id", participantID);
    bodyFormData.append("formkey", formKey);
    bodyFormData.append("ip_address", "223.23.423.3");
    let formdataString = JSON.stringify(data);
    const result1 = formdataString.replace(/true/g, '"true"'); // replace true
    const result2 = result1.replace(/false/g, '"false"'); // replace false
    const finalSchema = result2.replace(/null/g, '"null"'); // replace false
    bodyFormData.append("attempted_data_json", finalSchema);
    async function fetchAPI() {
      try {
        const response = await submitSurveyDetails(bodyFormData);
        if (response.status == "success") {
          navigate("/SurveyThanks");
          toast.success(response.message, { autoClose: 1500 });
          
        }
        if (response.status == "failure") {
          toast.warning(response.message, { autoClose: 1500 });
        }
        if (response.status == "error") {
          toast.error(response.message, { autoClose: 1500 });
        }
      } catch (error) {
        toast.error(error.message)
      } finally {
        setLoading(false)
      }
     
    }
    fetchAPI();
  }

  return (
    <div>
      {loading&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      <div className="container-fluid custom-container-fluid-background-survey">
        <div className="survey-header">
          {!loading?(<>
          <div className="row">
            
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box rounded-0">
                <center>
                  <img
                    src={companyLogo}
                    alt="image not available"
                    height={35}
                  ></img>
                </center>
                <br></br>
                <center>
                  {" "}
                  <h6>
                    <b>{surveyName}</b>
                  </h6>
                </center>
              </div>
            </div>
          </div>

          <div className="row form-box-top-margin">
            <div className="offset-md-1 col-md-10 offset-md-1">
              <div className="form-box mt-3 mb-3">
                <Form
                  src={{
                    display: "form",
                    components: formJson,
                  }}
                  

                  onSubmit={(i) => {
                    saveFormData(i.data);
                  }}
                />
              </div>
            </div>
          </div>
          </>):""}
          
        </div>
      </div>
    </div>
  );
};

export default SurveyForm;
